// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";
import 'element-ui/lib/theme-chalk/index.css'
import axios from "axios";
import "normalize.css/normalize.css"
import "@/assets/font/font.css";

if (process.env.NODE_ENV === 'development') {
    axios.defaults.baseURL = 'http://192.168.3.245:8081'
} else {
    axios.defaults.baseURL = 'https://admin2-back.globalshippingpal.com'
}
axios.defaults.timeout = 10000

Vue.config.productionTip = false
Vue.use(ElementUI, { locale });
/* eslint-disable no-new */
Vue.prototype.$https = axios
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js